import React from 'react'

import useNameFormatter from '@divvy-web/hooks.usenameformatter'
import { FormattedMessage } from '@divvy-web/i18n'
import Icon, { ICON_SIZE_REGULAR } from '@divvy-web/skylab.icon'
import Tooltip, { TOOLTIP_POSITION_TOP } from '@divvy-web/skylab.tooltip'

import { PRODUCT_CONST_STRINGS } from '@sputnik/resources/constants'

import styles from './styles.module.scss'

interface StatusTileBusinessNameProps {
  businessName?: string
  bdcOrgId?: string | null
}

const StatusTileBusinessName = ({ businessName, bdcOrgId }: StatusTileBusinessNameProps) => {
  const [getClassName, makeTestId] = useNameFormatter('StatusTileBusinessName')

  if (!businessName) return null

  if (!bdcOrgId) return <div data-testid={makeTestId('full-business-name')}>{businessName}</div>

  return (
    <div data-testid={makeTestId('full-business-name')}>
      {businessName}
      <span className={styles[getClassName('linked-to-bdc-org-name')]}>
        <>
          <FormattedMessage
            defaultMessage='Linked to "{businessName}"'
            id='sputnik.StatusTileBusinessName__2+0X3C'
            values={{ businessName }}
          />
          <Tooltip
            dataTestId={makeTestId('bdc-org-id-tooltip')}
            html={
              <FormattedMessage
                defaultMessage='Your {bill} Organization ID: {bdcOrgId}.'
                id='sputnik.StatusTileBusinessName__O0fsED'
                values={{ bdcOrgId, bill: PRODUCT_CONST_STRINGS.BILL }}
              />
            }
            position={TOOLTIP_POSITION_TOP}
          >
            <Icon
              dataTestId={makeTestId('info-icon')}
              name='info'
              size={ICON_SIZE_REGULAR}
            />
          </Tooltip>
        </>
      </span>
    </div>
  )
}

export default StatusTileBusinessName
